var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useState, useEffect } from "react";
import { UserTracking as tracking, UserFlowIds } from "@irati-tracking/onboarding";
import id from "@irati/utils/id";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import { H2 } from "@irati/ui/src/Typography";
import { DealListSort, DealStatus, TagKind } from "@irati/types";
import History from "@irati/utils/history";
import DealListComponent, { getDealList } from "@irati/deals/apollo/query/DealList";
import getCategoryFromTag from "@irati/deals/helpers/categories/getCategoryFromTag";
import FeedSliderGraph from "../FeedSlider";
import { CategorySelector, EditSelector, StyledHeader, CategoriesWrapper } from "./styled";
var SLIDER_VARIABLES = { statuses: [DealStatus.On, DealStatus.Unavailable], limit: 9, sort: DealListSort.Date };
var CustomCategories = function (_a) {
    var metadata = _a.metadata, formatMessage = _a.formatMessage, idNamespace = _a.idNamespace;
    var _b = useState(null), selectedCategory = _b[0], setSelectedCategory = _b[1];
    if (!metadata)
        return null;
    var favouriteCategories = metadata.config.favouriteCategories;
    if (!favouriteCategories || favouriteCategories.length === 0) {
        return null;
    }
    useEffect(function () {
        if (!selectedCategory) {
            if (favouriteCategories.length > 0) {
                selectCategoryOrTag(favouriteCategories[0]);
            }
        }
    }, []);
    var selectCategoryOrTag = function (selectedCategoryOrTag) {
        if ((selectedCategoryOrTag === null || selectedCategoryOrTag === void 0 ? void 0 : selectedCategoryOrTag.kind) === TagKind.DealCategory) {
            setSelectedCategory(selectedCategoryOrTag);
        }
        getCategoryFromTag(selectedCategoryOrTag.uuid).then(function (parentCategory) {
            var url = (parentCategory) ? parentCategory.url + "?tags=" + selectedCategoryOrTag.url : selectedCategoryOrTag.url;
            setSelectedCategory(__assign(__assign({}, selectedCategoryOrTag), { url: url }));
        });
    };
    var onClick = function (selectedId) {
        var selectedCategoryOrTag = favouriteCategories.find(function (_a) {
            var uuid = _a.uuid;
            return uuid === selectedId;
        });
        if (selectedCategoryOrTag) {
            tracking.perksHomepageCategoryClicked({
                category_id: selectedId,
                flow: UserFlowIds.CategoriesCustomisation
            });
            selectCategoryOrTag(selectedCategoryOrTag);
        }
    };
    var editClick = function () {
        tracking.perksHomepageEditClicked({
            flow: UserFlowIds.CategoriesCustomisation
        });
        History.push("/account/settings/customisation/categories");
    };
    var seeMoreClick = function () {
        tracking.perksHomepageSeeMoreClicked({
            category_id: selectedCategory.uuid,
            flow: UserFlowIds.CategoriesCustomisation
        });
    };
    var variables = selectedCategory ? __assign(__assign({}, SLIDER_VARIABLES), { tags: [selectedCategory.uuid].concat(selectedCategory.childrenIds || []) }) : undefined;
    return (React.createElement(React.Fragment, null,
        React.createElement(H2, { marginTop: 5 },
            React.createElement(FormattedMessage, { id: "perks.containers.homepage.customisation.header" })),
        React.createElement(CategoriesWrapper, { marginTop: 2 },
            favouriteCategories.map(function (_a) {
                var name = _a.name, uuid = _a.uuid;
                return (React.createElement(CategorySelector, { key: uuid, name: name, uuid: uuid, onClick: onClick, selected: uuid === (selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.uuid) }));
            }),
            React.createElement(EditSelector, { name: formatMessage({ id: "perks.containers.homepage.customisation.addEdit" }), onClick: editClick })),
        selectedCategory && variables && (React.createElement(DealListComponent, { variables: variables }, function (apollo) {
            var results = getDealList(apollo).results;
            return (React.createElement(React.Fragment, null,
                React.createElement(StyledHeader, { id: id("custom-categories-header", idNamespace), linkLabel: formatMessage({ id: "perks.containers.homepage.customisation.moreLink" }), linkTo: "/categories/" + selectedCategory.url, onClick: seeMoreClick }, selectedCategory === null || selectedCategory === void 0 ? void 0 : selectedCategory.name),
                React.createElement(FeedSliderGraph, { id: id("custom-categories-slider", idNamespace), data: results, showSectionHeader: false })));
        }))));
};
export default injectIntl(CustomCategories);
